export const messages = {
  en: {
    inspectionItemManage: {
      searchCondition: 'Search Condition',
      itemIdPlaceholder: 'Please enter item number',
      itemNamePlaceholder: 'Please enter inspection item',
      searchBtn: 'Search',
      resetBtn: 'Reset',
      inspectionItems: 'Inspection Items',
      page: {
        title: 'Inspection Items',
        subtitle: 'Define inspection items and the questions attached to them',
        empty: 'No inspection items found',
        loadFailed: 'Failed to load inspection items, please retry',
        tip: 'Click "Question" to manage the questions of an inspection item'
      },
      doc: 'Document',
      addBtn: 'Add',
      id: 'ID',
      itemName: 'Inspection Item',
      createTime: 'Create Time',
      remark: 'Remark',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      question: 'Question',
      addTitle: 'Add',
      editTitle: 'Edit',
      deleteTitle: 'Delete',
      itemNameLabel: 'Inspection Item',
      remarkLabel: 'Remark',
      requiredItem: 'Required, please fill in inspection item',
      requiredRemark: 'Required, please fill in remark',
      save: 'Save',
      cancel: 'Cancel',
      confirmDelete: 'Confirm deletion?',
      confirmDeleteMsg: 'Are you sure to delete the inspection item?',
      cancelDelete: 'Cancel',
      confirmDeleteBtn: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      fetchError: "Failed to fetch inspection item data",
    }
  },
  zh: {
    inspectionItemManage: {
      searchCondition: '查询条件',
      itemIdPlaceholder: '请输入项目编号',
      itemNamePlaceholder: '请输入巡检项目',
      searchBtn: '查询',
      resetBtn: '重置',
      inspectionItems: '巡检项目',
      page: {
        title: '巡检项目',
        subtitle: '维护巡检项目及其关联的巡检题目',
        empty: '暂无巡检项目',
        loadFailed: '巡检项目加载失败，请重试',
        tip: '点击「题目」可维护该巡检项目下的题目列表'
      },
      doc: '文档',
      addBtn: '添加',
      id: '编号',
      itemName: '巡检项目',
      createTime: '创建时间',
      remark: '备注',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      question: '题目',
      addTitle: '添加',
      editTitle: '修改',
      deleteTitle: '删除',
      itemNameLabel: '巡检项目',
      remarkLabel: '备注',
      requiredItem: '必填，请填写巡检项目',
      requiredRemark: '必填，请填写备注',
      save: '保存',
      cancel: '取消',
      confirmDelete: '请确认您的操作',
      confirmDeleteMsg: '确定删除巡检项目',
      cancelDelete: '点错了',
      confirmDeleteBtn: '确认删除',
      deleteSuccess: '删除成功',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      fetchError: "获取巡检项数据失败",
    }
  }
}